import { render, staticRenderFns } from "./HealthInstitution.vue?vue&type=template&id=09c91e40&scoped=true&"
import script from "./HealthInstitution.vue?vue&type=script&lang=js&"
export * from "./HealthInstitution.vue?vue&type=script&lang=js&"
import style0 from "./HealthInstitution.vue?vue&type=style&index=0&id=09c91e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c91e40",
  null
  
)

export default component.exports